module.exports = __webpack_public_path__ + "static/img/quan_6.01a6509b.png";